export default function updatePartnerNavLinks () {
    // update header link to direct to partners pages
    let headerLink = document.querySelector('.header-logo-link');
    headerLink.href = '/page/partners';

    // update navbar home link to direct to partners home page
    let navbarHomeLink = document.querySelector('#custom-nav-bar .home-nav a');
    navbarHomeLink.href = '/page/partners';
};
